import type { AxiosInstance } from 'axios'
import type {
  TelegramUserType,
  LoginResponseData,
  EmailSendCodeBody,
  EmailVerifyCodeBody,
  RefreshTokenResponseData,
  TokenResponseData,
  EmailSendCodeResponse,
  TokenRefreshBody,
} from 'src/types/auth'
import type { SuccessResponse } from 'src/types/response'
import type { WebAppInitData } from '@twa-dev/types'


export class AuthApi {
  api: AxiosInstance

  urls = {
    emailSendCode: () => 'auth/email/send-code/' as const,
    emailVerifyCode: () => 'auth/email/verify-code/' as const,
    refreshToken: () => 'jwt_token/refresh/' as const,
    telegram: () => 'auth/telegram/' as const,
    telegramTMA: () => 'auth/telegram-tma/' as const,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  emailSendCode = async (body: EmailSendCodeBody): Promise<EmailSendCodeResponse> => {
    const response = await this.api.post<SuccessResponse>(
      this.urls.emailSendCode(),
      body
    )
    return response.data
  }

  emailVerifyCode = async (body: EmailVerifyCodeBody) => {
    const response = await this.api.post<LoginResponseData>(
      this.urls.emailVerifyCode(),
      body
    )
    return response.data
  }

  telegramAuth = async (body: TelegramUserType) => {
    const response = await this.api.post<LoginResponseData>(
      this.urls.telegram(),
      body
    )
    return response.data
  }

  telegramTMAAuth = async (body: WebAppInitData) => {
    const response = await this.api.post<LoginResponseData>(
      this.urls.telegramTMA(),
      body
    )
    return response.data
  }

  refreshToken = async (token: string): Promise<TokenResponseData> => {
    const response = await this.api.post<RefreshTokenResponseData>(
      this.urls.refreshToken(),
      { refresh: token } as TokenRefreshBody
    )

    return  {
      access_token: response.data.access,
      refresh_token: response.data.refresh,
    }
  }
}
